import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';

import css from './PurchaseFlowMerchantHeader.module.scss';
import { buildSiteUrl } from 'src/utils/request-url';

export interface PurchaseFlowMerchantHeaderProps {
  className?: string;
  displayName: string;
  thumbnailUrl: string;
  isShowProfileImage: boolean;
}

const PurchaseFlowMerchantHeader = ({
  className,
  displayName,
  thumbnailUrl,
  isShowProfileImage,
}: PurchaseFlowMerchantHeaderProps) => {
  const classes = classNames(css.PurchaseFlowMerchantHeader, className);

  return (
    <div className={classes}>
      <div className={css.PurchaseFlowMerchantHeader__Inner}>
        <Link
          href={buildSiteUrl('', 'next')}
          prefetch={false}
          className={css.PurchaseFlowMerchantHeader__Link}
        >
          {isShowProfileImage && (
            <img
              className={css.PurchaseFlowMerchantHeader__Image}
              src={thumbnailUrl}
              alt=""
            />
          )}
          <span className={css.PurchaseFlowMerchantHeader__Description}>
            {displayName}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default PurchaseFlowMerchantHeader;
